import React, { useState, useEffect } from "react";
import { makeStyles, Hidden } from "@material-ui/core";
import { useRouter } from "next/router";

import TopHeader from "./topHeader/TopHeader";
import ReconditionneSubHeader from "./subHeader/reconditionneSubHeader";

function Header({ productTypes, commercialCategories }) {
  const classes = useStyle();
  const [resetSubHeader, setResetSubheader] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setResetSubheader((prev) => !prev);
  }, [router]);

  return (
    <>
      <Hidden smDown implementation="css">
        <div className={classes.container}>
          <TopHeader
            resetSubHeader={() => setResetSubheader((prev) => !prev)}
            productTypes={productTypes}
            commercialCategories={commercialCategories}
          />
        </div>
      </Hidden>
      <div className={classes.sticky}>
        <Hidden smDown implementation="css">
          {(router.pathname.includes("/[category]") ||
            router.pathname === "/reconditionne" ||
            router.pathname.includes("/catalogue") ||
            router.pathname === "/reconditionne/recherche") && (
            <>
              <ReconditionneSubHeader
                reset={resetSubHeader}
                productTypes={productTypes}
                commercialCategories={commercialCategories}
              />
            </>
          )}
        </Hidden>
      </div>
    </>
  );
}

const useStyle = makeStyles(() => ({
  container: {
    zIndex: 50,
    position: "relative",
  },
  sticky: {
    position: "sticky",
    top: "0px",
    zIndex: 40,
  },
}));

export default Header;
